import axios from 'axios';
import { Config } from 'config';
import { getAccessToken } from 'lib/Helper/Auth';
import { PagedContacts, Contact } from 'lib/Model/Contact';

export function fetchContacts(
  companyId: string,
  pageNumber: number,
  itemsPerPage: number,
  withRelated: boolean,
): Promise<PagedContacts> {
  return axios
    .get(`${Config.API_BASE_URL}intranet/companies/${companyId}/contacts`, {
      params: {
        page: pageNumber,
        page_size: itemsPerPage,
        show_related: withRelated,
      },
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return {
        total_count: response.data.total_count,
        data: response.data.data as Contact[],
      };
    });
}
